module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid57_980x819.d9d6305.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid57_980x819.jpg
// module id = 1SwA
// module chunks = 0